<template>
  <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center not-found-form">
            <h2 class="title text-danger">404 Not Found</h2>
            <h2 class="title">Oops! It seems that this page does not exist.</h2>
            <button class="btn btn-default btn-back" v-on:click="goHome()"><i class="fa fa-chevron-left icon"></i>BACK TO HOME</button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
      methods: {
        goHome: function() {
          window.open('https://universtage.com',"_self");
        }
      }
    }
</script>

<style scoped>
  .not-found-form {
    padding-top: 50px;
  }
  .btn-back {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .icon {
    padding-right: 10px;
    color: black;
  }
</style>

